export function locationChange(url) {
  return { type: 'APP_LOCATION_CHANGE', url }
}

export function setScreenContext(
  context,
  windows = [],
  messages = [],
  leaveSameContextWindowsOpen = false
) {
  if (!Array.isArray(windows)) {
    windows = [windows]
  }
  if (!Array.isArray(messages)) {
    messages = [messages]
  }
  return {
    type: 'SET_CONTEXT_WITH_MESSAGES',
    context,
    windows,
    messages,
    leaveSameContextWindowsOpen
  }
}

export function updateInteractableContainer(
  width,
  height,
  verticalOffset,
  horizontalOffset
) {
  // update does NOT apply relative window scaling
  return {
    type: 'UPDATE_INTERACTABLE_CONTAINER',
    width,
    height,
    verticalOffset,
    horizontalOffset
  }
}

export function setWindow(window, messages = null) {
  return {
    type: 'UPDATE_WIDGET',
    window,
    messages
  }
}

export function updateWindow(window, messages = null) {
  return {
    type: 'FORCE_UPDATE_WIDGET',
    window,
    messages
  }
}

export function setScreen(
  screen,
  contextChange = false,
  patientChange = false,
  messages
) {
  return {
    type: 'SET_VIEW',
    screen,
    contextChange,
    patientChange,
    messages
  }
}

export function closeWindow(refName) {
  return {
    type: 'CLOSE_WIDGET',
    ref: refName
  }
}

export function setZIndex(refName, zIndex) {
  return {
    type: 'SET_WIDGET_ZINDEX',
    ref: refName,
    zIndex
  }
}
